export default function registerDirectives(app) {
    app.directive("uppercase", {
        update: function (el) {
            el.value = el.value.toUpperCase()
        }
    })
}